import { render, staticRenderFns } from "./project-info.html?vue&type=template&id=5942a475&scoped=true&external"
import script from "./project-info.js?vue&type=script&lang=js&external"
export * from "./project-info.js?vue&type=script&lang=js&external"
import style0 from "./project-info.scss?vue&type=style&index=0&id=5942a475&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942a475",
  null
  
)

export default component.exports